// EmptyFacilities.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./addons.css";

function EmptyFacilities({ addFacility }) {
  const { t } = useTranslation("addons");

  return (
    <div className="empty-addons">
      <div className="empty-addons-content">
        <img
          src="/Group.svg"
          alt={t("facilities.empty.altImage")}
          className="empty-addons__image"
        />
        <h2 className="empty-addons__title">
          {t("facilities.empty.title")}
        </h2>
        <p className="empty-addons__text">
          {t("facilities.empty.text")}
        </p>
        {/* Use the matching prop here */}
        <button onClick={addFacility} className="empty-addons__button">
          <img className="add-square-icon" src="/add.svg" alt="" />
          {t("facilities.empty.button")}
        </button>
        <button
          onClick={addFacility}
          className="empty-addons__mobile-button"
        >
          <img className="add-square-icon" src="/add.svg" alt="" />
          {t("facilities.empty.button")}
        </button>
      </div>
    </div>
  );
}

export default EmptyFacilities;
